export function setupObscureJs() {
  let newNode;
  document.querySelectorAll('[obscure]').forEach((elem) => {
    newNode = document.createElement('span');
    newNode.innerHTML = elem.innerHTML;
    // eslint-disable-next-line no-unused-expressions
    elem.classList ? (newNode.classList = elem.classList) : false;
    // eslint-disable-next-line no-unused-expressions
    elem.id ? (newNode.id = elem.id) : false;

    for (const prop in elem.dataset) {
      newNode.innerHTML = newNode.innerHTML.replaceAll(
        '%' + prop.replace('p', ''),
        elem.dataset[prop]
      );
    }

    elem.parentNode.insertBefore(newNode, elem);
    elem.remove();
  });
}
